/* Gallery and quantity controls. Variant selection/cart use native Shopify URLs/forms. */
document.querySelectorAll('[data-velix-gallery]').forEach((gallery) => {
  const main = gallery.querySelector('[data-velix-main]');
  const caption = gallery.querySelector('[data-velix-caption]');
  if (!main || !caption) return;
  gallery.querySelectorAll('[data-velix-thumb]').forEach((button) => {
    button.addEventListener('click', () => {
      const image = button.querySelector('img');
      if (!image) return;
      main.src = image.src;
      main.alt = image.alt;
      caption.textContent = image.alt;
      gallery.querySelectorAll('[data-velix-thumb]').forEach((thumb) => {
        thumb.setAttribute('aria-pressed', String(thumb === button));
      });
    });
  });
});

document.querySelectorAll('[data-velix-product] .rc-qty').forEach((control) => {
  const input = control.querySelector('input[name="quantity"]');
  if (!input) return;
  control.querySelectorAll('[data-velix-qty]').forEach((button) => {
    button.hidden = false;
    button.addEventListener('click', () => {
      const current = Number(input.value);
      const minimum = Number(input.min) || 1;
      const maximum = Number(input.max) || 10;
      const step = button.dataset.velixQty === 'plus' ? 1 : -1;
      input.value = String(Math.min(maximum, Math.max(minimum, (Number.isFinite(current) ? Math.trunc(current) : minimum) + step)));
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
  });
});
